import { ContextualTip, useContextualTips } from "./contextual-tips-context";
import React from "react";


export type ContextualTipsTriggerProps = {
  children: React.ReactElement;
  tips: ContextualTip[];
  // If true, the children will be wrapped in a span to allow for non-dom elements
  wrapped?: boolean;
  wrapperClassName?: string;
};

export default function ContextualTipsTrigger({
  children,
  tips,
  wrapped,
  wrapperClassName,
}: ContextualTipsTriggerProps) {
  const { setTips } = useContextualTips();

  const handleMouseEnter = () => {
    setTips(tips);
  };

  // We need this to correctly manage overlapping tips triggers. When a child trigger loses focus,
  // the parent trigger will recover it using this callback.
  const handleMouseMove = () => {
    setTips(tips, {
      ifEmpty: true,
    });
  };

  const handleMouseLeave = () => {
    setTips([]);
  };

  if (wrapped) {
    return (
      <span
        className={wrapperClassName}
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </span>
    );
  }

  return React.cloneElement(children, {
    // @ts-expect-error
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
  });
}
